import { createSlice, createAsyncThunk, createEntityAdapter, PayloadAction } from '@reduxjs/toolkit';
import axios from '../utils/axios'
const initialState = {
    data: [],
    status: 'idle',
    one_user: null,
    projects: []
};

export const getUsers = createAsyncThunk('/users/get', async () => {

  let res = axios.get('users',{
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  }).catch((err)=>{
    console.log(err)
    // setError(err.response.data.message)
  })
  
   const data = await res
   console.log(data);
   if(data.data.success) {
    return data.data.data.users
   }
   else {
    return []
   }
   
})

export const getOneUser = createAsyncThunk('/users/getOne', async (id) => {

  let res = axios.get(`users/${id}`,{
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  }).catch((err)=>{
    console.log(err)
    // setError(err.response.data.message)
  })
  
   const data = await res
   console.log(data);
   return data.data.data.user
  
   
})


export const editUser = createAsyncThunk('/users/edit', async (item) => {

  let res = axios.put(`users/${item._id}`, item,{
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  }).catch((err)=>{
    console.log(err)
    // setError(err.response.data.message)
  })
  
   const data = await res
   console.log(data);
   if(data.data.success) {
    alert("Foydalanuvchi o'zgartirildi")
   }
  //  return data.data.data.user
  
   
})

export const getUserProjects =  createAsyncThunk('/users/getUserProjects', async (id) => {
  let res = axios.get(`projects/user/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  }).catch((err)=>{
  console.log(err)
  
})

 const data = await res
  console.log(data, 'projects');
 return data.data.data.Projects

})




const users = createSlice({
    name: 'users',
    initialState,
    reducers: {},
    extraReducers(builder) {
      builder
      .addCase(getUsers.pending, (state, action) => {
        state.status = 'loading'
      })
      .addCase(getUsers.rejected, (state, action) => {
        state.status = 'failed'
      })
      .addCase(getUsers.fulfilled,(state, action) => {
        // state.status = "idle";
        state.data = action.payload;
        state.status = 'succeeded'
      })
      .addCase(getOneUser.fulfilled,(state, action) => {
        // state.status = "idle";
        state.one_user = action.payload;
        state.status = 'succeeded'
      })
      .addCase(getUserProjects.fulfilled,(state, action) => {
        // state.status = "idle";
        state.projects = action.payload;
        state.status = 'succeeded'
      })
      .addCase(editUser.fulfilled,(state, action) => {
        state.status = "idle";
        // state.projects = action.payload;
        // state.status = 'succeeded'
      })
      }
  });
export const reducer = users.reducer;